import React, { useContext, useMemo } from 'react'
import { Translations } from '../services/TranslationService'
import { StateContext } from '../services/StateService'
import { trackPDPData } from '../services/TealiumService'
import DataTable from '@3mcom/mds-library/dist/node/DataTable'
import Link from '@3mcom/mds-library/dist/node/Link'
import '../css/ProductMiniTable.scss'

const COLUMNS = [
    {
        id: 'column1',
        accessor: 'column1',
        Header: '',
        style: {
            width: '50%'
        }
    },
    {
        id: 'column2',
        accessor: 'column2',
        Header: '',
        style: {
            color: 'black',
            width: '50%'
        }
    }
]

const ProductMiniTable = () => {
    const { productDetails, moreOptions } = useContext(StateContext)
    const translations = useContext(Translations)

    const tableData = useMemo(() => {
        if (!moreOptions?.classificationAttributes) return []
        if (!moreOptions?.options?.length) return []
        return moreOptions.classificationAttributes
            .filter((attribute) => {
                const attributeFound = moreOptions.options.find(
                    (selector) => selector.identifier === attribute.identifier
                )
                return Boolean(attributeFound)
            })
            .map((attribute) => ({
                column1: attribute.label,
                column2: attribute?.values?.join(', ') || ''
            }))
    }, [moreOptions])

    if (tableData.length === 0) return null

    return (
        <div className="sps2-pdp_miniTable">
            <Link
                className="mds-link_primary sps2-pdp_miniTable_change"
                href={productDetails?.canonical}
                onClick={() => {
                    trackPDPData(
                        `PDP Buying Zone Mini Table Link Click: ${translations.changeOptions}`,
                        'Engagement Event'
                    )
                }}
            >
                {translations.changeOptions}
            </Link>
            <DataTable.Table
                columns={COLUMNS}
                data={tableData}
                disableHeader={true}
                percentageBase={true}
            ></DataTable.Table>
        </div>
    )
}

export default ProductMiniTable
